import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { DOCUMENTS_PER_PAGE } from '@/config/common.config';
import { GetUsageHeaders, GetUsageHeadersVariables } from '@/graphql/contracts/_generated_/getUsageHeaders.query';
import { notificationService } from '@/services/notification/notification.client';
import GetUsageHeadersQuery from '@/graphql/contracts/getUsageHeaders.query.gql';

export type PaginatedFilteredUsageHeaders = GetUsageHeadersVariables;

export default function useGetUsageHeaders() {
  const [_getUsageHeaders, { loading, error, data }] = useLazyQuery<
  GetUsageHeaders,
  GetUsageHeadersVariables
  >(GetUsageHeadersQuery, {
    client: apolloClientContracts,
    fetchPolicy: 'network-only',
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });

  const getUsageHeaders = (dto?: PaginatedFilteredUsageHeaders) => {
    return _getUsageHeaders({
      variables: {
        ...dto,
        first: DOCUMENTS_PER_PAGE,
      },
    });
  };

  return {
    getUsageHeaders,
    usageHeaders: data?.usageHeaders?.items ?? [],
    isLoadingUsageHeaders: loading,
    errorUsageHeaders: error,
  } as const;
}
